@if (loaded$()) {
  <eiq-card class="language-settings" [title]="'Configured Languages'" [style]="'light'">
    <ng-container slot="actions">
      @if (translations$().length) {
        <eiq-button
          [icon]="faPlus"
          [text]="'Add New Language'"
          color="primary"
          [style]="'basic'"
          [disabled]="!canAddLanguage$()"
          testId="language-settings-add-language"
          (clicked)="addLanguage.emit()"
        ></eiq-button>
      }
    </ng-container>
    <div slot="content">
      @if (translations$().length) {
        @for (translation of translations$(); track translation.id) {
          <empathy-language-list-item
            [translation]="translation"
            [language]="languageMap$()[translation.code]"
            (remove)="onRemoveLanguage(translation)"
          ></empathy-language-list-item>
        }
      } @else {
        <empathy-languages-empty
          [message]="'Include the survey languages to monitor translations and ensure readiness before launch.'"
          [disableAddLanguage]="!canAddLanguage$()"
          (addLanguage)="addLanguage.emit()"
        ></empathy-languages-empty>
      }
    </div>
  </eiq-card>
}
